import { OnderwijsLocatieI } from '@models/onderwijs-locatie.model';

export interface OnderwijsLocatiesStateModel {
  onderwijsLocaties: OnderwijsLocatieI[];
  loading: boolean;
  error: string | null;
  loaded: boolean;
  selectedOnderwijsLocatieId: string;
  selectedSchool: OnderwijsLocatieI | null;
}

export const OnderwijsLocatiesInitialState: OnderwijsLocatiesStateModel = {
  onderwijsLocaties: [] as OnderwijsLocatieI[],
  loading: false,
  error: null,
  loaded: false,
  selectedOnderwijsLocatieId: '',
  selectedSchool: null,
};
